import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { usePropertyId } from '../../common/hooks/usePropertyId';
import { usePropertyPicturesData } from '../../common/hooks/usePropertyPicturesData';
import { withQueryData } from '../../common/withQueryData';
import Gallery, { GALLERY_PREVIEW_MODE } from './components/Gallery';
import SiteFooter from './components/SiteFooter';

const GalleryPageContent = ({ data, reload }) => {
  const albums = Array.isArray(data) ? data : [];

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <Container sx={{ py: 8 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ textAlign: 'center', mb: 6, fontWeight: 600 }}
        >
          Galeria zdjęć
        </Typography>

        {albums.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
            Brak zdjęć
          </Typography>
        ) : (
          albums.map((album) => (
            <Box key={album.id ?? album.name ?? 'root'} sx={{ mb: 6 }}>
              {album.name ? (
                <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 2 }}>
                  {album.name}
                </Typography>
              ) : null}
              <Gallery
                pictureUrls={album.pictureUrls || []}
                previewMode={GALLERY_PREVIEW_MODE.POPUP}
              />
            </Box>
          ))
        )}

        <SiteFooter />
      </Container>
    </Box>
  );
};

const GalleryPageContentWithQueryData = withQueryData(GalleryPageContent);

const GalleryPage = () => {
  const propertyId = usePropertyId();
  const { picturesQueryResults } = usePropertyPicturesData(propertyId);

  if (!propertyId) {
    return (
      <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
        <Container sx={{ py: 8 }}>
          <Typography variant="h3" component="h1" sx={{ textAlign: 'center', mb: 6, fontWeight: 600 }}>
            Galeria
          </Typography>
          <Gallery pictureUrls={[]} previewMode={GALLERY_PREVIEW_MODE.POPUP} />
          <SiteFooter />
        </Container>
      </Box>
    );
  }

  return <GalleryPageContentWithQueryData queryData={picturesQueryResults} />;
};

export default GalleryPage;
